module.exports = __webpack_public_path__ + "9a230a20e3dd5ea249fef4ac39a83df5.png";